import type { SVGProps } from "react";
import { cn } from "../lib/cn";

export interface SpinnerProps extends Omit<SVGProps<SVGSVGElement>, "children"> {
  /** Pixel size of the square. Defaults to 16. */
  size?: number;
  /** Accessible label. Pass an empty string when a visible label sits next to it. */
  label?: string;
}

/** Indeterminate progress. Use for work under ten seconds; longer work needs a real state. */
export function Spinner({ size = 16, label = "Loading", className, ...props }: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill="none"
      role={label ? "status" : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      className={cn("shrink-0 animate-vd-spin text-current", className)}
      {...props}
    >
      <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1.5" />
      <path
        d="M14.25 8A6.25 6.25 0 0 0 8 1.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
